import DesignMuseumFull from 'marketing-website/components/icons/DesignMuseumFull';
import statsImage from 'marketing-website/media/images/pages/case-studies/designmuseum/stats@2x.jpg';
import image01a from 'marketing-website/media/images/pages/case-studies/designmuseum/image-01-a@2x.jpg';
import image01b from 'marketing-website/media/images/pages/case-studies/designmuseum/image-01-b@2x.jpg';
import image02a from 'marketing-website/media/images/pages/case-studies/designmuseum/image-02-a@2x.jpg';
import image02b from 'marketing-website/media/images/pages/case-studies/designmuseum/image-02-b@2x.jpg';
import image03a from 'marketing-website/media/images/pages/case-studies/designmuseum/image-03-a@2x.jpg';
import image03b from 'marketing-website/media/images/pages/case-studies/designmuseum/image-03-b@2x.jpg';
import image04 from 'marketing-website/media/images/pages/case-studies/designmuseum/image-04@2x.jpg';
import image04a from 'marketing-website/media/images/pages/case-studies/designmuseum/image-04-a@2x.jpg';
import image04b from 'marketing-website/media/images/pages/case-studies/designmuseum/image-04-b@2x.jpg';
import image05a from 'marketing-website/media/images/pages/case-studies/designmuseum/image-05-a@2x.jpg';
import image05b from 'marketing-website/media/images/pages/case-studies/designmuseum/image-05-b@2x.jpg';

const designMuseumAssets = {
  heroLogo: DesignMuseumFull,
  statsImage: {
    alt: 'students using Marvel Prototyping',
    maxWidth: 1290,
    src: statsImage,
  },
  stats: [
    {
      id: 0,
      stat: '216+',
      title: 'design students',
      copy: 'joined their app design workshop since the beginning of 2017/2018',
    },
    {
      id: 1,
      stat: '20',
      title: 'students per session',
      copy:
        'The Design Museum has small sized classes to provide students with a tailored experience ',
    },
    {
      id: 2,
      stat: '5',
      title: 'minutes or less',
      copy: `is the time it takes to introduce Marvel to the kids and get them started with their project`,
    },
  ],
  singleImages: {
    first: {
      src: image04,
      maxWidth: 1141,
      alt: 'Students use Marvel’s Design Tool',
    },
  },
  doubleImages: {
    first: [
      {
        src: image01a,
        maxWidth: 536,
        alt: 'Design Museum Interior',
      },
      {
        src: image01b,
        maxWidth: 551,
        alt: 'Teacher teaching students how to use Marvel Prototyping',
      },
    ],
    second: [
      {
        src: image02a,
        maxWidth: 580,
        alt: 'Paper sketching of prototypes',
      },
      {
        src: image02b,
        maxWidth: 558,
        alt: 'Students start their first project using Marvel',
      },
    ],
    third: [
      {
        src: image03a,
        maxWidth: 536,
        alt: 'paper prototyping',
      },
      {
        src: image03b,
        maxWidth: 550,
        alt: 'Students using Marvel on desktop',
      },
    ],
    fourth: [
      {
        src: image04a,
        maxWidth: 460,
        alt: 'Students using Marvel on desktop',
      },
      {
        src: image04b,
        maxWidth: 460,
        alt: 'Marvel Prototyping and Design Museum',
      },
    ],
    fifth: [
      {
        src: image05a,
        maxWidth: 556,
        alt: 'Students using Marvel on desktop',
      },
      {
        src: image05b,
        maxWidth: 556,
        alt: 'Students using Marvel on desktop',
      },
    ],
  },
};

export default designMuseumAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/designmuseum.js